import { createFileRoute } from '@tanstack/react-router';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading } from '@/components/Loading';
import { activeConfig } from '@/config';
import FAQDocumentsPage from '@/components/pages/faq/documents';

const ProtectedFAQDocumentsPage = withAuthenticationRequired(FAQDocumentsPage, {
  onRedirecting: () => <Loading />,
});

export const Route = createFileRoute('/faq/documents/')({
  head: () => ({
    meta: [{ title: `FAQ Documents | ${activeConfig.branding.appName}` }],
  }),
  component: ProtectedFAQDocumentsPage,
});
